export const EMPTY_CONTENT = '–';

export const VALID_IMAGE_EXTENSIONS = new Set(['image/png', 'image/jpeg', 'image/jpg']);
